import { Reducer } from "redux";
import * as Actions from "./actions";
import { ActionTypes } from "./action-types";
import { generateUniqueNumberId } from "src/utils/uniqueId";

export interface IInformationFeedState {
    isLoading: boolean;
    isLoadingMore: boolean;
    hasMore: boolean;
    items: Spintr.IInformationFeedItem[];
    params: any;
    categories: any[];
    hasFetchedCategories: boolean;
    importantArticles: Spintr.IInformationFeedItem[];
    hasFetchedImportantArticles: boolean;
    isLoadingImportantArticles: boolean;
}

const initialState: IInformationFeedState = {
    isLoading: true,
    isLoadingMore: false,
    hasMore: false,
    items: [],
    params: {},
    categories: [],
    hasFetchedCategories: false,
    importantArticles: [],
    hasFetchedImportantArticles: false,
    isLoadingImportantArticles: false
};

const informationFeedReducer: Reducer<IInformationFeedState, Actions.InformationFeedAction> = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FetchInformationFeedPending:
            if (action.meta.silent) {
                return state;
            }

            return {
                ...state,
                isLoading: action.meta.params.skip === 0,
                isLoadingMore: action.meta.params.skip > 0,
            };


        case ActionTypes.FetchInformationFeedFulfilled:
            if (action.meta.isRSS) {
                action.payload.data = (action.payload.data as Spintr.IRssFeedEntry[]).map((item) => ({
                    allowComments: true,
                    commentCount: 0,
                    content: item.text,
                    date: item.date.toString(),
                    id: generateUniqueNumberId(),
                    imageUrl: item.imageUrl,
                    isBlogPost: false,
                    likers: [],
                    priorityLevel: 1,
                    title: item.title,
                    url: item.url,
                    isFavourite: false,
                    isFollowing: false,
                    isRss: true,
                    rssName: item.feed.name
                })) as Spintr.IInformationFeedItem[];
            }

            action.payload.data = action.payload.data as Spintr.IInformationFeedItem[];

            return {
                ...state,
                items: action.meta.params.skip > 0
                    ? [...state.items, ...action.payload.data]
                    : action.payload.data,
                params: action.meta.params,
                hasMore: action.payload.data.length === action.meta.params.take,
                isLoading: false,
                isLoadingMore: false,
            };

        case ActionTypes.SetInformationFeedLoading:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.FetchContentCategoriesFulfilled:
            return {
                ...state,
                hasFetchedCategories: true,
                categories: action.payload.data.items,
            };
            
        case ActionTypes.FetchImportantArticlesPending:
            return {
                ...state,
                isLoadingImportantArticles: true,
            };

        case ActionTypes.FetchImportantArticlesRejected:
            return {
                ...state,
                isLoadingImportantArticles: false,
            };

        case ActionTypes.FetchImportantArticlesFulfilled:
            return {
                ...state,
                hasFetchedImportantArticles: true,
                isLoadingImportantArticles: false,
                importantArticles: action.payload.data,
            };

        case ActionTypes.MarkAsReadPending:
            return {
                ...state,
                items: state.items.map((item) => item.id === action.meta.uberId
                    ? { ...item, isUnread: false }
                    : item),
                importantArticles: state.importantArticles.filter(x => x.id !== action.meta.uberId),
            };

        case ActionTypes.ClearInformationFeed:
            return {
                ...initialState,
            };

        case ActionTypes.RemoveImportantArticle:
            return {
                ...state,
                importantArticles: state.importantArticles.filter(x => x.id !== action.meta.id),
            };

        case ActionTypes.AddImportantArticle:
            return {
                ...state,
                importantArticles: [action.meta.item, ...state.importantArticles],
            };
            
        case ActionTypes.AddItem:
            return {
                ...state,
                items: [action.meta.item, ...state.items],
            };

        case ActionTypes.UpdateItem:
            return {
                ...state,
                items: state.items.map((item) => item.id === action.meta.item.id
                    ? action.meta.item
                    : item),
                importantArticles: state.importantArticles.map((item) => item.id === action.meta.item.id
                    ? action.meta.item
                    : item),
            };

        default:
            return state;
    }
};

export default informationFeedReducer;